import { Header } from "../components/header/Header";

export function About() {
    return (
        <>
        <Header />
        <div className="flex justify-center">
            <h1>This is an about</h1>
        </div>
        </>
    );
}